export const HOUSEHOLD_ROLES = ['owner', 'member', 'viewer'] as const
export type HouseholdRole = (typeof HOUSEHOLD_ROLES)[number]

/** Rôles qui peuvent modifier l'inventaire. */
export const canWrite = (role: HouseholdRole): boolean => role === 'owner' || role === 'member'
/** Rôles qui peuvent gérer le foyer (membres, invitations, nom). */
export const canManage = (role: HouseholdRole): boolean => role === 'owner'

export const REGISTRATION_MODES = ['open', 'code', 'closed'] as const
export type RegistrationMode = (typeof REGISTRATION_MODES)[number]
